module.exports = __webpack_public_path__ + "static/media/NotasFiscais8.b28699d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/LancNotasFiscais/NotasFiscais8.png
// module id = 2138
// module chunks = 0